import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Calendar, User, ArrowRight } from 'lucide-react';
import { articlesAPI } from '@/lib/api';

const ArticleDetailPage = () => {
  const { id } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticle = async () => {
      try {
        const response = await articlesAPI.getById(id);
        setArticle(response.data);
      } catch (error) {
        console.error('Failed to fetch article:', error);
        setArticle(null);
      } finally {
        setLoading(false);
      }
    };
    fetchArticle();
  }, [id]);

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center"><div className="text-[#D4AF37]">در حال بارگذاری...</div></div>;
  }

  if (!article) {
    return <div className="min-h-screen flex items-center justify-center"><div className="text-zinc-400">مقاله یافت نشد</div></div>;
  }

  return (
    <div className="min-h-screen" data-testid="article-detail-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Link
          to="/articles"
          className="inline-flex items-center gap-2 text-[#D4AF37] hover:text-[#F3E5AB] transition-colors mb-8"
        >
          <ArrowRight size={20} />
          بازگشت به مقالات
        </Link>

        <article className="glass-effect border border-white/10 rounded-2xl overflow-hidden">
          <img
            src={article.image_url}
            alt={article.title_fa}
            className="w-full h-[400px] object-cover"
          />
          <div className="p-8 md:p-12">
            <span className="inline-block px-3 py-1 bg-[#D4AF37]/10 text-[#D4AF37] rounded-full text-xs font-medium mb-4">
              {article.category}
            </span>
            <h1 className="text-3xl md:text-4xl font-light text-white mb-6 leading-relaxed" data-testid="article-title">
              {article.title_fa}
            </h1>
            <div className="flex items-center gap-6 text-sm text-zinc-400 mb-8 pb-8 border-b border-white/10">
              <div className="flex items-center gap-2">
                <User size={16} />
                <span>{article.author}</span>
              </div>
              <div className="flex items-center gap-2">
                <Calendar size={16} />
                <span>{new Date(article.published_date).toLocaleDateString('fa-IR')}</span>
              </div>
            </div>
            <div className="prose prose-invert max-w-none">
              <p className="text-lg text-zinc-300 leading-relaxed whitespace-pre-line">
                {article.content_fa}
              </p>
            </div>
          </div>
        </article>

        <div className="mt-12 glass-effect border border-[#D4AF37]/20 rounded-2xl p-8 text-center">
          <h3 className="text-2xl font-light text-white mb-4">نیاز به مشاوره دارید؟</h3>
          <p className="text-zinc-400 mb-6">برای راهنمایی بیشتر با مشاوران ما تماس بگیرید</p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-6 py-3 bg-[#D4AF37] text-black rounded-full font-medium hover:bg-[#F3E5AB] transition-colors"
          >
            درخواست مشاوره
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ArticleDetailPage;